/**
 * @flow
 * @relayHash 188017ba984ae242fae9f162a03576d6
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type Background_viewer$ref = any;
export type MediaFileStateType = "available" | "deleted" | "%future added value";
export type MediaFileTypeEnum = "image" | "live" | "video" | "wallpaper" | "%future added value";
export type queries_MediaFilesBackground_QueryVariables = {|
  page: number,
  type?: ?MediaFileTypeEnum,
  states?: ?$ReadOnlyArray<?MediaFileStateType>,
|};
export type queries_MediaFilesBackground_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: Background_viewer$ref
  |}
|};
export type queries_MediaFilesBackground_Query = {|
  variables: queries_MediaFilesBackground_QueryVariables,
  response: queries_MediaFilesBackground_QueryResponse,
|};
*/


/*
query queries_MediaFilesBackground_Query(
  $page: Int!
  $type: MediaFileTypeEnum
  $states: [MediaFileStateType]
) {
  viewer {
    ...Background_viewer_1Bem2T
    id
  }
}

fragment Background_viewer_1Bem2T on Viewer {
  mediaFiles: mediaFilesPaginate(pageSize: 20, page: $page, type: $type, states: $states) {
    mediaFiles {
      id
      title
      filename
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "page",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "type",
    "type": "MediaFileTypeEnum",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "states",
    "type": "[MediaFileStateType]",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "queries_MediaFilesBackground_Query",
  "id": null,
  "text": "query queries_MediaFilesBackground_Query(\n  $page: Int!\n  $type: MediaFileTypeEnum\n  $states: [MediaFileStateType]\n) {\n  viewer {\n    ...Background_viewer_1Bem2T\n    id\n  }\n}\n\nfragment Background_viewer_1Bem2T on Viewer {\n  mediaFiles: mediaFilesPaginate(pageSize: 20, page: $page, type: $type, states: $states) {\n    mediaFiles {\n      id\n      title\n      filename\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "queries_MediaFilesBackground_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Background_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "page",
                "variableName": "page",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "states",
                "variableName": "states",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "type",
                "variableName": "type",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "queries_MediaFilesBackground_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": "mediaFiles",
            "name": "mediaFilesPaginate",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "page",
                "variableName": "page",
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "pageSize",
                "value": 20,
                "type": "Int"
              },
              {
                "kind": "Variable",
                "name": "states",
                "variableName": "states",
                "type": "[MediaFileStateType]"
              },
              {
                "kind": "Variable",
                "name": "type",
                "variableName": "type",
                "type": "MediaFileTypeEnum"
              }
            ],
            "concreteType": "mediaFilesPaginate",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "mediaFiles",
                "storageKey": null,
                "args": null,
                "concreteType": "MediaFile",
                "plural": true,
                "selections": [
                  v1,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "title",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "filename",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          v1
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'cec22930a2ca4d84458e47966c7b2945';
module.exports = node;



// WEBPACK FOOTER //
// src/__generated__/queries_MediaFilesBackground_Query.graphql.js